module.exports = __webpack_public_path__ + "img/piveau-logo-black.13f01495.svg";